import { Topic } from "../../Topic/Models/Topic";

export const endpoints = {
  applications: {
    get: () => "/api/v1/internal/applications",
    getByPrefix: (appId: string) => `/api/v1/internal/applications/${appId}`,
    getAssignedUsers: (appId: string) => `/api/v1/internal/applications/${appId}/users`,
    assignUser: (appId: string) => `/api/v1/internal/applications/${appId}/users`,
    unassignUser: (appId: string, userId: number) =>
      `/api/v1/internal/applications/${appId}/users/${userId}`,
    allMetrics: () => "/api/v1/internal/applications/quickmetrics"
  },

  subscriptions: {
    status: (appId: string) => `api/v1/internal/subscriptions/app/${appId}/status`,
    subscribe: (appId: string) => `api/v1/internal/subscriptions/app/${appId}/subscribe`,
    unsubscribe: (appId: string) => `api/v1/internal/subscriptions/app/${appId}/unsubscribe`
  }
};
